import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c855fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fixed-value" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "发票类型："),
  /*#__PURE__*/_createElementVNode("span", null, "增值税普通发票（电子）")
], -1))
const _hoisted_2 = { class: "fixed-value" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, "开票金额：", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.visible) = $event)),
    width: "45%",
    title: "请填写开票信息",
    onCancel: _ctx.handleCancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        key: "back",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("取 消")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.showForm)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.toConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("开发票")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "primary",
            onClick: _ctx.confirmInvoice
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认开票")
            ]),
            _: 1
          }, 8, ["onClick"]))
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("p", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.invoiceAmount) + "元", 1)
      ]),
      (_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_form, {
              ref: "formRef",
              rules: _ctx.rules,
              model: _ctx.invoiceInfo,
              "label-col": {style: 'width: 120px' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, { label: "抬头类型" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio_group, {
                      value: _ctx.invoiceInfo.type,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.invoiceInfo.type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio, { value: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode("企业单位")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_radio, { value: 2 }, {
                          default: _withCtx(() => [
                            _createTextVNode("个人")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                (_ctx.invoiceInfo.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_form_item, {
                        label: "企业名称",
                        name: "name"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.invoiceInfo.name,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.invoiceInfo.name) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, {
                        label: "企业税号",
                        name: "duty"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.invoiceInfo.duty,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.invoiceInfo.duty) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "注册地址" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.invoiceInfo.address,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.invoiceInfo.address) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "企业电话" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.invoiceInfo.phone,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.invoiceInfo.phone) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "开户银行" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.invoiceInfo.bank,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.invoiceInfo.bank) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "银行账号" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.invoiceInfo.bankAct,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.invoiceInfo.bankAct) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 1,
                      label: "抬头名称",
                      name: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.invoiceInfo.name,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.invoiceInfo.name) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })),
                _createVNode(_component_a_form_item, { label: "发票备注" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.invoiceInfo.desc,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.invoiceInfo.desc) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  label: "电子邮箱",
                  name: "email"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: _ctx.invoiceInfo.email,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.invoiceInfo.email) = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["rules", "model"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_a_descriptions, {
              title: "",
              column: 1
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "抬头类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.invoiceInfo.type === 1 ? '企业' : '个人'), 1)
                  ]),
                  _: 1
                }),
                (_ctx.invoiceInfo.type === 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_a_descriptions_item, { label: "企业名称" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceInfo.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "企业税号" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceInfo.duty), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "注册地址" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceInfo.address), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "企业电话" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceInfo.phone), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "开户银行" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceInfo.bank), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_descriptions_item, { label: "银行账号" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.invoiceInfo.bankAct), 1)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 1,
                      label: "抬头名称"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.invoiceInfo.name), 1)
                      ]),
                      _: 1
                    })),
                _createVNode(_component_a_descriptions_item, { label: "发票备注" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.invoiceInfo.desc), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "电子邮箱" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.invoiceInfo.email), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}